import React from 'react';
import styles from './DividedStack.module.scss';

interface DividedStackProps {
  items: (React.ReactNode | null | undefined)[];
}

function DividedStack({items}: DividedStackProps) {
  const nonEmpty = items.filter((item) => item != null);

  if (nonEmpty.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      {nonEmpty.map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={index}>
          {index > 0 ? <hr className={styles.divider} /> : null}
          {item}
        </React.Fragment>
      ))}
    </div>
  );
}

export default DividedStack;
